var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    rofviewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_linear_2410_4461)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8113 3.625H14.8555V6.06612H13.4582C12.3714 6.06612 12.1385 6.58004 12.1385 7.35093V9.02121H14.752V11.6422H12.1385V18.3746H9.42155V11.6422H7.14447V9.02119H9.42155V7.09397C9.42155 4.85841 10.793 3.625 12.8113 3.625Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M21.1155 6.67139C21.198 7.21588 21.2394 7.7658 21.2394 8.3165C21.2394 14.4852 16.1111 19.4859 9.78493 19.4859C6.20194 19.4859 3.00368 17.8813 0.903259 15.3694C2.59383 19.2704 6.47805 21.9997 11.0003 21.9997C17.0754 21.9997 22.0003 17.0749 22.0003 10.9997C22.0021 9.51186 21.7011 8.03918 21.1155 6.67139Z",
    fill: "url(#paint1_radial_2410_4461)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.711027 9.31951C1.75752 12.0001 6.24947 12.7506 10.7441 10.9959C15.2386 9.24113 18.2991 5.52632 16.9873 2.96508C16.2123 1.45188 13.6794 0.0908274 10.6911 0.00488281H10.6748C5.86485 0.144515 1.83 3.37233 0.481591 7.77438C0.446882 8.2999 0.525115 8.82675 0.711027 9.31951Z",
    fill: "url(#paint2_radial_2410_4461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2410_4461",
    x1: 0,
    y1: 11,
    x2: 22,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C87D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2015,
    stopColor: "#377CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5611,
    stopColor: "#2B5DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#193092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2410_4461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4595 14.3323) rotate(-40.0917) scale(12.8919 9.78035)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2410_4461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.88432 5.97444) scale(10.4547 10.4547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736,
    stopColor: "white",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1652,
    stopColor: "white",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "white",
    stopOpacity: 0.463
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "white",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "white",
    stopOpacity: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6941,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    stopColor: "white",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.bd6ec1e14cccb5f4d797825500ed4a0e.svg";
export { ForwardRef as ReactComponent };